module.exports = __webpack_public_path__ + "img/destino.c68f05b0.png";